import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Toolbar,
  Grid2,
  Typography,
  TextField
} from '@mui/material'
import { confirmable } from 'react-confirm'

import WarningIcon from '@mui/icons-material/Warning'

const ConfirmationDialogIrreversible = ({ show, proceed, confirmation }) => {
  const [reason, setReason] = useState('')

  const handleConfirm = () => {
    proceed({ confirm: true, reason })
  }

  const handleCancel = () => {
    proceed({ confirm: false })
  }

  return (
    <Dialog
      open={show}
      onClose={handleCancel}
      fullWidth
      maxWidth="sm"
      sx={{ backgroundColor: '#f9b692' }}
    >
      <DialogTitle sx={{ m: 0, p: 0 }}>
        <Toolbar sx={{ color: '#fefefe', backgroundColor: '#d84327', fontWeight: 600 }}>
          <WarningIcon style={{ color: '#fefefe', marginRight: '10px' }} />
          Vous allez effectuer une action irréversible
        </Toolbar>
      </DialogTitle>

      <DialogContent sx={{ m: 2, pt: 4 }}>
        <Typography variant="h6" mt={2} mb={4}>{confirmation}</Typography>

        <TextField
          fullWidth
          label="Raison de la suppression"
          variant="outlined"
          value={reason}
          onChange={e => setReason(e.target.value)}
          sx={{ mb: 4 }}
        />

        <Grid2 container spacing={2} justifyContent="right">
          <Grid2>
            <Button
              onClick={handleCancel}
              color="standard"
            >
              RENONCER
            </Button>
          </Grid2>

          <Grid2>
            <Button
              onClick={handleConfirm}
              color="error"
              variant="contained"
              disabled={!reason.trim()}
            >
              CONFIRMER LA SUPPRESSION
            </Button>
          </Grid2>
        </Grid2>
      </DialogContent>
    </Dialog>
  )
}

export default confirmable(ConfirmationDialogIrreversible)